export default __webpack_public_path__ + "static/media/opex_icon.b73971d5.svg";